import _extends from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @format */

import React from 'react';
import { connect } from 'react-redux';
import { removeShoSessionTokens } from "../../utils/sessionHelper";
import { syncShoSession, openLoginModal, closeLoginModal } from "../../reducers/user";
import { memberProfilePropType, memberProfileDefaultProps } from "../../constants/app";
function withMemberProfile(WrappedComponent) {
  var Container = function Container(props) {
    var removeAndSyncShoSession = function removeAndSyncShoSession() {
      removeShoSessionTokens();
      var _memberProfileDefault = _objectSpread(_objectSpread({}, memberProfileDefaultProps), props),
        authenticated = _memberProfileDefault.authenticated,
        authorized = _memberProfileDefault.authorized;
      if (authorized && !authenticated) {
        props.syncShoSession();
      }
    };
    return __jsx(WrappedComponent, _extends({
      removeAndSyncShoSession: removeAndSyncShoSession
    }, props));
  };
  var mapStateToProps = function mapStateToProps(_ref) {
    var user = _ref.user;
    return {
      authorized: user.authorized,
      firstName: user.firstName,
      lastName: user.lastName,
      ffn: user.ffn,
      points: user.points,
      authenticated: user.authenticated,
      showOptIn: user.showOptIn,
      showNewUserModal: user.showNewUserModal
    };
  };
  var mapDispatchToProps = {
    openLoginModal: openLoginModal,
    closeLoginModal: closeLoginModal,
    syncShoSession: syncShoSession
  };
  return connect(mapStateToProps, mapDispatchToProps)(Container);
}
export default withMemberProfile;